<template>
  <div class="email-wrapper">
    <label
      v-has-error:email_subject
      :class="['email-subject-label', 'text-can-error', { ['error-label']: errors.subject }]"
      name="email_subject">
      email subject
    </label>
    <input
        v-model="emailSubject"
        v-touch:email_subject
        v-has-error:email_subject
        rows="5"
        type="text"
        name="email_subject"
        class="email-subject border-can-error"
        placeholder="email subject"
        @change="subjectUpdate"
        @blur="initSubjectInteraction" 
        data-cy="email-subject-input"/>
    <span
        v-if="errors.subject && !useNewCampaign"
        class="error-label error-message">
      {{errors.subject}}
    </span>
    <label
        v-has-error:has_email_template
        :class="['email-message', 'text-can-error', { ['error-label']: errors.content }]"
        name="email_message">
      email message
    </label>
    <div class="email-preview">
      <div v-if="selectedEmailTemplate && selectedEmailTemplate.preview_image" class="image-preview">
        <img :src="selectedEmailTemplate.preview_image" alt="campaign-email" />
      </div>
      <div v-else>
        <span class="loading-text text-20">generating email preview</span>
        <span class="loading-text text-10">(if time exceeds more than 1min. please refresh the page)</span>
      </div>
      <div class="email-action">
        <a class="button clear edit-button" @click="selectedEmailModal = 'email-creation'">edit</a>
        <a class="button clear delete-button" @click="deleteEmailTemplate(selectedEmailTemplate.id)">delete</a>
      </div>
    </div>
    <span
        v-if="errors.content && !useNewCampaign"
        class="error-label error-message">
      {{errors.content}}
    </span>

    <email-template-selection-modal
      v-if="selectedEmailModal === 'email-template-selection'"
      :email="emailTemplates"
      @closeEmailTemplateSelectionModal="cancelModalWithoutChanges"
      @openEmailCreationModalAndSetTemplate="openEmailCreationModalAndSetTemplate"
      @refreshTemplateList="getEmailTemplates"
    />

    <email-creation-modal
      v-if="selectedEmailModal === 'email-creation'"
      :email="emailTemplates"
      :campaign="campaign"
      :email-subject="emailSubject"
      @closeEmailCreationModal="cancelModalWithoutChanges"
      @toggleSend="$emit('toggleEmailSend'); templateUpdate()"
      @updateEmailSubject="subjectUpdate"
      @update:campaign="(frag) => $emit('updateEmail', frag)"
      :selected-email-template.sync="selectedEmailTemplate"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { Touch, HasError } from "@springbig/sb-components";
  import EmailTemplateSelectionModal from "../Campaigns2/email-modal/email-template-selection.vue";
  import EmailCreationModal from "../Campaigns2/email-modal/email-creation.vue";
  import {campaignAPI} from "../../services/api/campaignAPI.js";
  import {beeAPI} from "../../services/api/beeAPI.js";



  export default {
    props: {
      email: Object,
      campaign: Object,
      emailSend: Boolean,
      isInView: Boolean,
    },

    name: 'CampaignEmail',

    directives: {
      Touch, HasError
    },

    components: {
      EmailCreationModal,
      EmailTemplateSelectionModal
    },

    data() {
      return {
        emailTemplates: {},
        emailSubject: '',
        editor: null,
        errors: {
          content: null,
          subject: null,
        },
        noInteraction: {
          content: true,
          subject: true,
        },
        selectedEmailModal: null,
        selectedEmailTemplate: null,
        showContentError: false,
        showSubjectError: false,
        validEmail: null,
      }
    },

    methods: {
      async deleteEmailTemplate(templateId) {
        const resp = await beeAPI.deleteEmailTemplate(templateId);
        if(resp.status !== 200){
          this.$set(this.errors, 'content', 'an unexpected error occurred! template was not correctly deleted');
          return
        }
        this.selectedEmailTemplate = null;
        this.emailSubject = null;
        this.$emit('toggleEmailSend');
        this.templateUpdate()
        this.updateEmailInteraction();
      },

      async getEmailTemplates() {
        this.emailTemplates = await campaignAPI.getEmailTemplates(this.campaign.id);
        this.selectedEmailTemplate = this.emailTemplates?.specific_campaign_template
      },

      cancelModalWithoutChanges() {
        this.selectedEmailModal = null
        this.$set(this.noInteraction, 'subject', false)
        this.$emit("cancelModalWithoutChanges");
      },

      openEmailCreationModalAndSetTemplate(template) {
        this.selectedEmailTemplate = template;
        this.selectedEmailModal = "email-creation";
      },

      initSubjectInteraction() {
        if(this.useNewCampaign) {
          return;
        }

        if (this.noInteraction['subject']) {
          this.$set(this.noInteraction, 'subject', false)
          this.updateEmailInteraction()
          this.validateSubject()
        }
      },

      templateUpdate() {
        if(this.useNewCampaign) {
          this.updateEmail('template')
        } else {
          this.validateTemplate()
          if (!this.errors.content) { this.updateEmail('template') }
        }
      },

      subjectUpdate(_event, subjectString = null) {
        if (subjectString != null) {this.emailSubject = subjectString};
        if(this.useNewCampaign) {
          this.updateEmail('subject')
        } else {
          this.validateSubject()
          if (!this.errors.subject) { this.updateEmail('subject') }
        }
      },

      updateEmail(updateString) {
        let email = updateString == 'template' ? { has_email_template: !!this.selectedEmailTemplate } : { email_subject:  this.emailSubject }
        this.$emit('updateEmail', email)
      },

      updateEmailInteraction() {
        let noInteraction = this.noUserInteraction ? { email: true } : {}
        if (!this.emailSend) { noInteraction = {} }
        this.UPDATE_STATE_OBJECT({stateKey: 'noUserInteractions', itemKey: 'email', itemObject: noInteraction})
      },

      validateTemplate() {
        this.noInteraction.content && this.$set(this.noInteraction, 'content', false)
        const contentError = !!this.selectedEmailTemplate ? null : 'email template needs to be created'
        this.$set(this.errors, 'content', contentError)
        this.validateEmail()
      },

      validateEmail() {
        this.validEmail = !this.errors.content && !this.errors.subject
        const validObject = this.validEmail || !this.emailSend ? {} : { emailValid: this.validEmail }
        this.UPDATE_STATE_OBJECT({itemKey: 'email', itemObject: validObject})
      },

      validateSubject() {
        if (!this.emailSubject || this.emailSubject.length < 1) {
          this.$set(this.errors, 'subject', 'email subject cannot be empty')
        } else if (this.emailSubject.length > 255) {
          this.$set(this.errors, 'subject', 'email subject cannot be over 255 characters')
        } else {
          this.$set(this.errors, 'subject', null)
        }
        this.validateEmail()
      },

      ...mapActions({
        UPDATE_STATE_OBJECT: 'UPDATE_STATE_OBJECT'
      })
    },

    created() {
      if (this.email) {
        this.emailSubject = this.email.subject
        this.emailSubject && this.$set(this.noInteraction, 'subject', false)
      }
      if (this.emailSend) {
        this.updateEmailInteraction()
        this.getEmailTemplates().then(() => {
          if (!this.selectedEmailTemplate){
            this.selectedEmailModal = "email-template-selection"
            this.$set(this.noInteraction, 'content', false)
          }
        })
      }
    },

    computed: {
      noUserInteraction: function () {
        return !!this.noInteraction.content || !!this.noInteraction.subject
      },
      ...mapGetters(['useNewCampaign'])
    },

    watch: {
      emailSend: function () {
        this.emailSend && this.updateEmailInteraction()
        !this.emailSend && this.UPDATE_STATE_OBJECT({stateKey: 'noUserInteractions', itemKey: 'email', itemObject: {}})
      },

      noUserInteraction: function () {
        this.updateEmailInteraction()
      }
    }
  }
</script>

<style scoped>
.email-preview .error {
  border: 1px solid #f91253;
}

.email-preview {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 500px;
}

.email-preview .button.clear {
  background-color: transparent;
  color: #128ff9;
  font-size: 16px;
}

.email-preview .email-action {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
}

.email-preview .edit-button {
  font-family: "AileronLight";
  font-weight: bolder;
}

.email-preview .delete-button {
  font-family: "AileronLight";
}

.email-preview >>> .sb-loading-icon {
  width: 200px;
}

.email-preview .loading-text {
  color: #4a4a4a;
  display: block;
  text-align: center;
  width: 150px;
}

.email-preview .text-20 {
  font-size: 20px;
}

.email-preview .text-10 {
  font-size: 10px;
}
</style>